const API_CONFIG = {
  BASE_URL_BACKEND: "https://backescr.dirtecno.com",
};

export default API_CONFIG;
